@if (isPCCOLoading$ | async) {
  <app-page-loading></app-page-loading>
} @else {
  <div class="sidebar-wrapper">
    <app-sidebar-header (backButtonClicked)="goToPreviousPage()" [showBackButton]="currentPage !== 1">
      <div smallTitle>{{ model.generalData?.id ? 'Edit' : 'Add' }} Prime Contract Change Order</div>
      <div mainTitle>
        @if (currentPage === 1) {
          General Information
        } @else {
          Select Change Request
        }
      </div>
    </app-sidebar-header>
    <div class="main-content m-0 p-0 flex flex-col">
      @if (currentPage === 1) {
        <app-prime-contact-change-order-general-sidebar
          #pccoGeneral
          [model]="model.generalData"
        ></app-prime-contact-change-order-general-sidebar>
      } @else {
        <app-prime-change-order-cor-select
          #selectedCORs
          (selectedCORsChange)="selectedCORsChanged($event)"
          (corTotalChange)="corTotal = $event"
        ></app-prime-change-order-cor-select>
      }
    </div>

    <div class="my-6 mx-7 flex justify-between gap-4">
      @if (currentPage === 1) {
        <app-simple-button class="ml-auto" (click)="onNext()">Next</app-simple-button>
      } @else {
        <div class="font-bold text-sm">Total CORs Selected</div>

        <div class="font-bold text-sm">
          {{ corTotal | money: 'positiveComa' }}
        </div>

        <div>
          <app-simple-button
            [disabled]="model.cors.length === 0"
            [ngClass]="{ 'opacity-50 pointer-events-none': model.cors.length === 0 }"
            (click)="saveForm()"
            buttonStyle="color_accent_filled"
          >
            {{ model.generalData?.id ? 'Update' : 'Save' }}
          </app-simple-button>
        </div>
      }
    </div>
  </div>
}
